var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWireframing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 60H7C4.24 60 2 57.76 2 55V16C2 15.45 2.45 15 3 15C3.55 15 4 15.45 4 16V55C4 56.65 5.35 58 7 58H57C58.65 58 60 56.65 60 55V21C60 20.45 60.45 20 61 20C61.55 20 62 20.45 62 21V55C62 57.76 59.76 60 57 60Z",
    fill: "#FE8A8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52H12C10.9 52 10 51.1 10 50V46C10 44.9 10.9 44 12 44H52C53.1 44 54 44.9 54 46V50C54 51.1 53.1 52 52 52ZM12 46V50H52V46H12Z",
    fill: "#FE8A8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24H37C36.45 24 36 23.55 36 23C36 22.45 36.45 22 37 22H53C53.55 22 54 22.45 54 23C54 23.55 53.55 24 53 24Z",
    fill: "#FF8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32H37C36.45 32 36 31.55 36 31C36 30.45 36.45 30 37 30H53C53.55 30 54 30.45 54 31C54 31.55 53.55 32 53 32Z",
    fill: "#FF8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40H37C36.45 40 36 39.55 36 39C36 38.45 36.45 38 37 38H53C53.55 38 54 38.45 54 39C54 39.55 53.55 40 53 40Z",
    fill: "#FF8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22H13C11.35 22 10 23.35 10 25V37C10 38.65 11.35 40 13 40H30C31.65 40 33 38.65 33 37V25C33 23.35 31.65 22 30 22ZM31 25.24V36.76L23.19 31L31 25.24ZM21.5 29.76L13.69 24H29.32L21.51 29.76H21.5ZM19.81 31L12 36.76V25.24L19.81 31ZM21.5 32.24L29.31 38H13.68L21.49 32.24H21.5Z",
    fill: "#FE8A8A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 12.5C55.3284 12.5 56 11.8284 56 11C56 10.1716 55.3284 9.5 54.5 9.5C53.6716 9.5 53 10.1716 53 11C53 11.8284 53.6716 12.5 54.5 12.5Z",
    fill: "#FF8C8C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 12.5C49.3284 12.5 50 11.8284 50 11C50 10.1716 49.3284 9.5 48.5 9.5C47.6716 9.5 47 10.1716 47 11C47 11.8284 47.6716 12.5 48.5 12.5Z",
    fill: "#FF8C8C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 12.5C43.3284 12.5 44 11.8284 44 11C44 10.1716 43.3284 9.5 42.5 9.5C41.6716 9.5 41 10.1716 41 11C41 11.8284 41.6716 12.5 42.5 12.5Z",
    fill: "#FF8C8C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18H39C38.7 18 38.41 17.86 38.22 17.62L34.52 13H3C2.45 13 2 12.55 2 12V9C2 6.24 4.24 4 7 4H57C59.76 4 62 6.24 62 9V17C62 17.55 61.55 18 61 18ZM39.48 16H60V9C60 7.35 58.65 6 57 6H7C5.35 6 4 7.35 4 9V11H35C35.3 11 35.59 11.14 35.78 11.38L39.48 16Z",
    fill: "#FF8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireframing);
export default __webpack_public_path__ + "static/media/wireframing.6ba7a518b1aa4a8c5c0e50415498a98d.svg";
export { ForwardRef as ReactComponent };